import type { BrandJson } from "@coras-io/brand-tokens";
import {
  DEFAULT_CURRENCIES,
  DEFAULT_LOCALES,
  type SiteConfig,
} from "../../src/types";
import brandConfig from "./brand.json";

export const brand = brandConfig as BrandJson;

export const site: SiteConfig = {
  distributorId: "c8640453429d48b9a8f64b81cfe63970",
  title: "FurthrShop Experiences",
  description: "Book tickets to West End Shows, Concerts and more",
  locale: "en-GB",
  currency: "AUD",
  locales: DEFAULT_LOCALES,
  currencies: DEFAULT_CURRENCIES,
  favicons: ["apple-touch-icon.png", "favicon.png"],
  logo: "/assets/images/logo.png",
  domain: "experiences.furthrshop.com",
  detectLocale: true,
  detectCurrency: false,
};
